import '@angular/compiler';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

// Usually we would only enableProdMode in production by checking
// environment.production. However, the whole app was built in prod mode and it
// would probably take a whole epic to fix all the assertions that fail in dev
// mode. The only difference in prod mode and dev mode is that there are two
// detection change runs in dev mode compared to one in prod mode, and the
// second run will check many assertion that cause errors such as
// ExpressionChangedAfterItHasBeenCheckedError.
enableProdMode();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
